function cov_ljltp17zy() {
  var path = "/app/src/components/long-term-content/components/subvention-faq-link/index.ts";
  var hash = "7e842867d25939b8e452ca0805b079b0e8aaf960";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/components/subvention-faq-link/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7e842867d25939b8e452ca0805b079b0e8aaf960"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ljltp17zy = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ljltp17zy();
export { SubventionFaqLink } from './subvention-faq-link';